import { useEffect, useState } from "react";

/**
 * One-shot entrance animation gate. Returns `true` on first mount and flips to
 * `false` after `durationMs` so Recharts can diff paths in place on later
 * updates instead of replaying the stroke-dashoffset draw.
 */
export function useEntranceAnimation(durationMs: number) {
  const [isInitialMount, setIsInitialMount] = useState(true);
  useEffect(() => {
    const id = setTimeout(() => setIsInitialMount(false), durationMs);
    return () => clearTimeout(id);
  }, [durationMs]);
  return isInitialMount;
}
